module.exports = __webpack_public_path__ + "assets/img/14ccc7a6c084e1949b0d314bf7cc9ea8.png";